import { motion } from "framer-motion";
import { Target, Zap, Settings, BarChart3 } from "lucide-react";

const points = [
  { icon: Target, text: "Built around lead-to-revenue systems, not just traffic" },
  { icon: Zap, text: "Focus on speed-to-lead and conversion" },
  { icon: Settings, text: "Automation ensures no missed opportunities" },
  { icon: BarChart3, text: "Full visibility into what drives actual customers" },
];

export const WhyItWorksSection = () => {
  return (
    <section className="py-20 px-4 bg-secondary">
      <div className="max-w-4xl mx-auto">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Why Our Approach Works Across Industries
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5">
          {points.map((point, i) => (
            <motion.div
              key={i}
              className="flex items-start gap-4 p-5 rounded-xl bg-card border border-border"
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <point.icon className="w-5 h-5 text-primary" />
              </div>
              <p className="text-foreground font-medium pt-1.5">{point.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
